import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme=>({
    root: {
        width: '100%',
	},
	accordionRoot:{
		backgroundColor:'#316ea7',
		color: 'white',
		fontWeight: 'bold',
		border: '10px solid #1E5282'
	},
	titleItemAccordion:{
		padding: '10px 0px 0px 0px',
	},	
	accordionBody:{
		backgroundColor:'#D4D8E1',
		color: 'black',
		padding: '10px 0px 0px 0px',
	},	
	heading: {
		fontSize: theme.typography.pxToRem(15),
		flexBasis: '33.33%',
		flexShrink: 0,
	},
	secondaryHeading: {
		fontSize: theme.typography.pxToRem(15),
		color: 'white',
	},    
	centerForm: {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'nowrap',
		alignContent:'center',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor:'#D4D8E1',
		color: 'black',
		padding: '10px 0px 0px 0px',		
	}
}))